import React, { useState, useEffect } from 'react';
import { inventario } from '../utils/api';
import toast from 'react-hot-toast';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', maximumFractionDigits:0 }).format(n || 0);
const f = { fontFamily:"'Plus Jakarta Sans',sans-serif" };

export default function InventarioPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('todos');

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    try { const res = await inventario.get(); setData(res.data); }
    catch (err) { toast.error('Error cargando inventario'); }
    finally { setLoading(false); }
  };

  const estadoConfig = {
    agotado:  { label:'Agotado',         color:'#dc2626', bg:'#fee2e2' },
    critico:  { label:'Crítico',          color:'#dc2626', bg:'#fee2e2' },
    bajo:     { label:'Por reabastecer',  color:'#f97316', bg:'#fff7ed' },
    optimo:   { label:'Stock óptimo',     color:'#3d7a00', bg:'#e8f9d4' },
  };

  const filtered = data?.items?.filter(i => {
    const matchSearch = !search || i.title?.toLowerCase().includes(search.toLowerCase()) || i.sku?.toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === 'todos' || i.estado_stock === filter;
    return matchSearch && matchFilter;
  }) || [];

  return (
    <div style={{ ...f, padding:'24px 28px', background:'#f5f5ef', minHeight:'100vh' }}>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24 }}>
        <div>
          <h1 style={{ fontSize:24, fontWeight:800, color:'#1a1a1a', letterSpacing:'-0.5px', margin:0 }}>Inventario</h1>
          <p style={{ fontSize:13, color:'#aaa', marginTop:4 }}>
            {data ? `${data.resumen?.total} productos · actualizado ahora` : 'Cargando...'}
          </p>
        </div>
        <button onClick={loadData}
          style={{ padding:'8px 18px', borderRadius:20, fontSize:12, fontWeight:700, border:'1px solid #e8e8e0', background:'#fff', color:'#7c5ef8', cursor:'pointer', fontFamily:'Plus Jakarta Sans,sans-serif' }}>
          ⟳ Actualizar
        </button>
      </div>

      {data && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 }}>
          {[
            ['Agotados / Críticos', (data.resumen?.agotados||0) + (data.resumen?.criticos||0), '#dc2626', '#fee2e2', 'Stock = 0 o < 5 días'],
            ['Por reabastecer',      data.resumen?.bajos,   '#f97316', '#fff7ed', 'Entre 5 y 30 días'],
            ['Stock óptimo',         data.resumen?.optimos, '#3d7a00', '#e8f9d4', 'Más de 30 días'],
            ['Total productos',      data.resumen?.total,   '#7c5ef8', '#ede9fe', 'SKUs activos en ML'],
          ].map(([label, val, color, bg, sub]) => (
            <div key={label} style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:18, padding:20, position:'relative', overflow:'hidden' }}>
              <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:color }}></div>
              <div style={{ fontSize:11, fontWeight:700, color:'#aaa', textTransform:'uppercase', letterSpacing:'.5px', marginBottom:8 }}>{label}</div>
              <div style={{ fontSize:30, fontWeight:800, color, letterSpacing:'-1px' }}>{val || 0}</div>
              <div style={{ fontSize:11, color:'#bbb', marginTop:4 }}>{sub}</div>
            </div>
          ))}
        </div>
      )}

      <div style={{ display:'flex', gap:10, marginBottom:16, alignItems:'center', flexWrap:'wrap' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar producto o SKU..."
          style={{ background:'#fff', border:'1.5px solid #e8e8e0', borderRadius:10, padding:'9px 14px', fontSize:12, color:'#1a1a1a', fontFamily:'Plus Jakarta Sans,sans-serif', outline:'none', width:240 }} />
        <div style={{ display:'flex', gap:4 }}>
          {[['todos','Todos'],['agotado','Agotados'],['critico','Críticos'],['bajo','Por reabastecer'],['optimo','Óptimo']].map(([id,label]) => (
            <button key={id} onClick={() => setFilter(id)}
              style={{ padding:'7px 14px', borderRadius:20, fontSize:11, fontWeight:700, border:'1px solid', cursor:'pointer', fontFamily:'Plus Jakarta Sans,sans-serif',
                borderColor: filter===id ? '#7c5ef8' : '#e8e8e0',
                background: filter===id ? '#ede9fe' : '#fff',
                color: filter===id ? '#7c5ef8' : '#888' }}>
              {label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ background:'#fff', border:'1px solid #e8e8e0', borderRadius:18, overflow:'hidden' }}>
        {loading ? (
          <div style={{ textAlign:'center', padding:60, color:'#bbb', fontSize:13 }}>Cargando inventario...</div>
        ) : (
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
            <thead>
              <tr style={{ borderBottom:'1px solid #f0f0e8', background:'#fafaf5' }}>
                {['Producto','SKU','Stock ML','Stock Bodega','Total','Vtas 30D','Días Stock','Quiebre','Estado'].map(h => (
                  <th key={h} style={{ textAlign:'left', color:'#bbb', padding:'14px 10px', fontSize:10, fontWeight:700, textTransform:'uppercase', letterSpacing:'.4px' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={9} style={{ textAlign:'center', padding:40, color:'#ccc', fontSize:13 }}>No hay productos en esta categoría</td></tr>
              ) : filtered.map(item => {
                const ec = estadoConfig[item.estado_stock] || estadoConfig.optimo;
                const diasNum = parseInt(item.dias_stock) || 999;
                const quiebre = item.ventas_30d > 0 && diasNum < 999
                  ? new Date(Date.now() + diasNum * 86400000).toLocaleDateString('es-CO', { day:'2-digit', month:'2-digit' })
                  : '-';
                return (
                  <tr key={item.item_id} style={{ borderBottom:'1px solid #f8f8f4' }}>
                    <td style={{ padding:'12px 10px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <div style={{ width:6, height:6, borderRadius:'50%', background:ec.color, flexShrink:0 }}></div>
                        {item.thumbnail ? (
                          <img src={item.thumbnail.replace('http://','https://')} alt="" style={{ width:36, height:36, borderRadius:6, objectFit:'cover', flexShrink:0 }} onError={e => e.target.style.display='none'} />
                        ) : (
                          <div style={{ width:36, height:36, borderRadius:6, background:'#f5f5ef', flexShrink:0 }}></div>
                        )}
                        <div>
                          <div style={{ color:'#1a1a1a', fontWeight:600, maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.title || item.item_id}</div>
                          <div style={{ color:'#bbb', fontSize:10, marginTop:1 }}>{item.item_id}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ padding:'12px 10px', color:'#bbb', fontFamily:'monospace', fontSize:11 }}>{item.sku || '-'}</td>
                    <td style={{ padding:'12px 10px', color: item.available_quantity === 0 ? '#dc2626' : '#1a1a1a', fontWeight:700 }}>{item.available_quantity}</td>
                    <td style={{ padding:'12px 10px', color:'#bbb' }}>-</td>
                    <td style={{ padding:'12px 10px', color:'#1a1a1a', fontWeight:600 }}>{item.available_quantity}</td>
                    <td style={{ padding:'12px 10px', color:'#888' }}>{item.ventas_30d || 0}</td>
                    <td style={{ padding:'12px 10px' }}>
                      <span style={{ color: diasNum <= 5 ? '#dc2626' : diasNum <= 30 ? '#f97316' : '#3d7a00', fontWeight:700 }}>
                        {diasNum >= 999 ? '∞' : `${diasNum}d`}
                      </span>
                    </td>
                    <td style={{ padding:'12px 10px', color:'#bbb', fontSize:11 }}>{quiebre}</td>
                    <td style={{ padding:'12px 10px' }}>
                      <span style={{ padding:'3px 10px', borderRadius:20, fontSize:10, fontWeight:700, background:ec.bg, color:ec.color }}>
                        {ec.label}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
